import {createSvgIcon} from '../create-svg-icon';

export const FastForwardIcon = createSvgIcon(
  <path d="M15 9.86 18.03 12 15 14.14V9.86m-9 0L9.03 12 6 14.14V9.86M13 6v12l8.5-6L13 6zM4 6v12l8.5-6L4 6z" />
, 'FastForwardOutlined');
